

class UIInteractionEvents  {
    static BACK_CLICKED = Symbol("BACK_CLICKED");
    static CLEAR_ERROR_BUTTON_CLICKED = Symbol("CLEAR_ERROR_BUTTON_CLICKED");
    static PUBLIC_NAV_BRAND_CLICKED = Symbol("PUBLIC_NAV_BRAND_CLICKED");
    static PRIVATE_NAV_BRAND_CLICKED = Symbol("PRIVATE_NAV_BRAND_CLICKED");
    static PRIVATE_NAV_SEARCH_SPACES_CLICKED = Symbol("PRIVATE_NAV_SEARCH_SPACES_CLICKED");
    static PUBLIC_NAV_LOGIN_BUTTON_CLICKED = Symbol("PUBLIC_NAV_LOGIN_BUTTON_CLICKED");
    static FACEBOOK_LOGIN_BUTTON_CLICKED = Symbol("FACEBOOK_LOGIN_START_BUTTON_CLICKED");
    static LOGOUT_BUTTON_CLICKED = Symbol("LOGOUT_BUTTON_CLICKED");
    static LOGIN_FAILED_ALERT_CLOSE = Symbol("LOGIN_FAILED_ALERT_CLOSE");
    static RENDERED_VIEW_REQUIRES_MEMBER = Symbol("RENDERED_VIEW_REQUIRES_MEMBER");
    static RENDERED_VIEW_REQUIRES_PROFILE = Symbol("RENDERED_VIEW_REQUIRES_PROFILE");
    static GOOGLE_API_LIB_REQUIRED = Symbol("GOOGLE_API_LIB_REQUIRED");
    static GOOGLE_PLACES_AUTO_COMPLETE_SERP_CHANGE = Symbol("GOOGLE_PLACES_AUTO_COMPLETE_SERP_CHANGE")
    static LOAD_INITIAL_SPACES = Symbol("LOAD_INITIAL_SPACES");
    static SPACE_MARKER_CLICK = Symbol("SPACE_MARKER_CLICK");
    static MAX_PRICE_CHANGED = Symbol("MAX_PRICE_CHANGED");
    static MIN_PRICE_CHANGED = Symbol("MIN_PRICE_CHANGED");
    static ORDER_BY_CHANGED = Symbol("SORT_BY_CHANGED");
    static FILTER_BUTTON_CLICKED = Symbol("FILTER_BUTTON_CLICKED");
    static MAP_ZOOM_CHANGED = Symbol("MAP_ZOOM_CHANGED");
    static MAP_CENTER_CHANGED = Symbol("MAP_CENTER_CHANGED");
    static MAP_SEARCH_NEW_AREA_BUTTON_CLICKED = Symbol("MAP_SEARCH_NEW_AREA_BUTTON_CLICKED");
    static PAGINATION_CHANGE = Symbol("PAGINATION_CHANGE");
    static LOAD_SPACES = Symbol("LOAD_SPACES");

    static PUBLIC_SPACE_SET_SPACE_ID = Symbol("PUBLIC_SPACE_SET_SPACE_ID");
    static PRIVATE_SPACE_DETAILS_SET_SPACE_ID = Symbol("PRIVATE_SPACE_DETAILS_SET_SPACE_ID");
    static SPACE_DETAILS_BUTTON_CLICKED = Symbol("SPACE_DETAILS_BUTTON_CLICKED");
    static GET_MY_SPACES = Symbol("GET_MY_SPACES");
    static MY_SPACES_BUTTON_CLICK = Symbol("MY_SPACES_BUTTON_CLICK");
    static MY_SPACE_UNMOUNTED = Symbol("MY_SPACE_UNMOUNTED");
    static MY_SPACES_SPACE_PREVIEW_BUTTON_CLICKED = Symbol("MY_SPACES_SPACE_PREVIEW_BUTTON_CLICKED");
    static MY_SPACES_EDIT_SPACE_BUTTON_CLICKED = Symbol("MY_SPACES_EDIT_SPACE_BUTTON_CLICKED");
    static MY_SPACES_MANAGE_SPACE_BUTTON_CLICKED = Symbol("MY_SPACES_MANAGE_SPACE_BUTTON_CLICKED");
    static MY_SPACES_NEW_SPACE_BUTTON_CLICKED = Symbol("MY_SPACES_NEW_SPACE_BUTTON_CLICKED");
    static SPACE_PREVIEW_MANAGE_SPACE_BUTTON_CLICKED = Symbol("SPACE_PREVIEW_MANAGE_SPACE_BUTTON_CLICKED");
    static SPACE_PREVIEW_EDIT_SPACE_BUTTON_CLICKED = Symbol("SPACE_PREVIEW_EDIT_SPACE_BUTTON_CLICKED");
    static SPACE_BALANCE_BUTTON_CLICK = Symbol("SPACE_BALANCE_BUTTON_CLICK");


    static PROFILE_CREATE_ADDRESS_AUTOCOMPLETE_CHANGED = Symbol("PROFILE_CREATE_ADDRESS_AUTOCOMPLETE_CHANGED");
    static PROFILE_CREATE_DISPLAY_NAME_CHANGED = Symbol("PROFILE_CREATE_DISPLAY_NAME_CHANGED");
    static PROFILE_CREATE_EMAIL_CHANGED = Symbol("PROFILE_CREATE_EMAIL_CHANGED");
    static PROFILE_CREATE_PHONE_NUMBER_CHANGED = Symbol("PROFILE_CREATE_PHONE_NUMBER_CHANGED");
    static PROFILE_CREATE_ABOUT_CHANGED = Symbol("PROFILE_CREATE_ABOUT_CHANGED");
    static PROFILE_CREATE_PAYMENT_ADDRESS_NAME_CHANGED = Symbol("PROFILE_CREATE_PAYMENT_ADDRESS_NAME_CHANGED");
    static PROFILE_CREATE_SECONDARY_ADDRESS_CHANGED = Symbol("PROFILE_CREATE_SECONDARY_ADDRESS_CHANGED");
    static PROFILE_CREATE_SAVE_SUBMITTED = Symbol("PROFILE_CREATE_SAVE_SUBMITTED");

    static EMAIL_VERIFICATION_CODE_CHANGED = Symbol("EMAIL_VERIFICATION_CODE_CHANGED");
    static EMAIL_VERIFICATION_EMAIL_REQUESTED = Symbol("EMAIL_VERIFICATION_EMAIL_REQUESTED");
    static EMAIL_VERIFICATION_CHECK_SUBMITTED = Symbol("EMAIL_VERIFICATION_CHECK_SUBMITTED");

    static PHONE_NUMBER_VERIFICATION_CODE_CHANGED = Symbol("PHONE_NUMBER_VERIFICATION_CODE_CHANGED");
    static PHONE_NUMBER_VERIFICATION_SMS_REQUESTED = Symbol("PHONE_NUMBER_VERIFICATION_SMS_REQUESTED");
    static PHONE_NUMBER_VERIFICATION_CHECK_SUBMITTED = Symbol("PHONE_NUMBER_VERIFICATION_CHECK_SUBMITTED");

    static MY_ADVERTISEMENTS_BUTTON_CLICK = Symbol("MY_ADVERTISEMENTS_BUTTON_CLICK");
    static ADVERTISEMENT_CREATE_TITLE_CHANGED = Symbol("ADVERTISEMENT_CREATE_TITLE_CHANGED");
    static ADVERTISEMENT_CREATE_DESCRIPTION_CHANGED = Symbol("ADVERTISEMENT_CREATE_DESCRIPTION_CHANGED");
    static ADVERTISEMENT_CREATE_SAVE_SUBMITTED = Symbol("ADVERTISEMENT_CREATE_SAVE_SUBMITTED");
    static GET_MY_ADVERTISEMENTS = Symbol("GET_MY_ADVERTISEMENTS");
    static MY_ADVERTISEMENTS_UNMOUNTED = Symbol("MY_ADVERTISEMENTS_UNMOUNTED");
    static MY_ADVERTISEMENTS_NEW_ADVERTISEMENT_BUTTON_CLICKED = Symbol("MY_ADVERTISEMENTS_NEW_ADVERTISEMENT_BUTTON_CLICKED");
    static MY_ADVERTISEMENTS_ADVERTISEMENT_PREVIEW_BUTTON_CLICKED = Symbol("MY_ADVERTISEMENTS_ADVERTISEMENT_PREVIEW_BUTTON_CLICKED");
    static MY_ADVERTISEMENTS_EDIT_ADVERTISEMENT_BUTTON_CLICKED = Symbol("MY_ADVERTISEMENTS_EDIT_ADVERTISEMENT_BUTTON_CLICKED");
    static OPEN_ADVERTISEMENT_CLICKED = Symbol("OPEN_ADVERTISEMENT_CLICKED");
    static CLOSE_ADVERTISEMENT_CLICKED = Symbol("CLOSE_ADVERTISEMENT_CLICKED");
    static ADVERTISING_BILLING_BUTTON_CLICK = Symbol("ADVERTISING_BILLING_BUTTON_CLICK");

    // static PRIVATE_ADVERTISEMENT_PREVIEW_VIEW_MOUNTED = Symbol("PRIVATE_ADVERTISEMENT_PREVIEW_VIEW_MOUNTED");

    static ADVERTISEMENT_OWNER_PROFILE_UNMOUNT = Symbol("ADVERTISEMENT_OWNER_PROFILE_UNMOUNT");
    static SPACE_OWNER_PROFILE_UNMOUNT = Symbol("SPACE_OWNER_PROFILE_UNMOUNT");
    static ADVERTISEMENT_VIEW_MOUNTED = Symbol("ADVERTISEMENT_VIEW_MOUNTED");
    static ADVERTISEMENT_OWNER_PROFILE_VIEW_MOUNTED = Symbol("ADVERTISEMENT_OWNER_PROFILE_VIEW_MOUNTED");
    static SPACE_OWNER_PROFILE_VIEW_MOUNTED = Symbol("SPACE_OWNER_PROFILE_VIEW_MOUNTED");
    static PREVIEW_ADVERTISEMENT_EDIT_ADVERTISEMENT_BUTTON_CLICKED = Symbol("PREVIEW_ADVERTISEMENT_EDIT_ADVERTISEMENT_BUTTON_CLICKED");
    static SPACE_RESERVATION_BUTTON_CLICKED = Symbol("SPACE_RESERVATION_BUTTON_CLICKED");
    static ADVERTISEMENT_RESERVATION_BUTTON_CLICKED = Symbol("ADVERTISEMENT_RESERVATION_BUTTON_CLICKED");
    static EDIT_PROFILE_BUTTON_CLICKED = Symbol("EDIT_PROFILE_BUTTON_CLICKED");

    static FILE_UPLOAD_STARTED = Symbol("FILE_UPLOAD_STARTED");
    static SHOWN_IMAGE_CHANGING = Symbol("SHOWN_IMAGE_CHANGING");
    static SHOWN_IMAGE_CHANGE_FINISHED = Symbol("SHOWN_IMAGE_CHANGE_FINISHED");
    static DELETE_IMAGE = Symbol("DELETE_IMAGE");

    static SPACE_CREATE_ADDRESS_AUTOCOMPLETE_CHANGED = Symbol("SPACE_CREATE_ADDRESS_AUTOCOMPLETE_CHANGED");
    static SPACE_CREATE_ADDRESS_AUTOCOMPLETE_CLEARED = Symbol("SPACE_CREATE_ADDRESS_AUTOCOMPLETE_CLEARED");
    static SPACE_CREATE_TITLE_CHANGED = Symbol("SPACE_CREATE_TITLE_CHANGED");
    static SPACE_CREATE_DESCRIPTION_CHANGED = Symbol("SPACE_CREATE_DESCRIPTION_CHANGED");
    static SPACE_CREATE_PRICE_CHANGED = Symbol("SPACE_CREATE_PRICE_CHANGED");
    static SPACE_CREATE_MINIMUM_DAYS_CHANGED = Symbol("SPACE_CREATE_MINIMUM_DAYS_CHANGED");
    static SPACE_CREATE_SAVE_SUBMITTED = Symbol("SPACE_CREATE_SAVE_SUBMITTED");

    static SPACE_EDIT_TITLE_CHANGED = Symbol("SPACE_EDIT_TITLE_CHANGED");
    static SPACE_EDIT_DESCRIPTION_CHANGED = Symbol("SPACE_EDIT_DESCRIPTION_CHANGED");
    static SPACE_EDIT_PRICE_CHANGED = Symbol("SPACE_EDIT_PRICE_CHANGED");
    static SPACE_EDIT_MINIMUM_DAYS_CHANGED = Symbol("SPACE_EDIT_MINIMUM_DAYS_CHANGED");
    static SPACE_EDIT_ADDRESS_AUTOCOMPLETE_CHANGED = Symbol("SPACE_EDIT_ADDRESS_AUTOCOMPLETE_CHANGED");
    static SPACE_EDIT_ADDRESS_AUTOCOMPLETE_CLEARED = Symbol("SPACE_EDIT_ADDRESS_AUTOCOMPLETE_CLEARED");
    static SPACE_EDIT_SAVE_SUBMITTED = Symbol("SPACE_EDIT_SAVE_SUBMITTED");
    static SPACE_EDIT_SET_SPACE_ID = Symbol("SPACE_EDIT_SET_SPACE_ID");

    static MY_SPACES_LIST_SPACE_BUTTON_CLICKED = Symbol("MY_SPACES_LIST_SPACE_BUTTON_CLICKED");
    static MY_SPACES_UNLIST_SPACE_BUTTON_CLICKED = Symbol("MY_SPACES_UNLIST_SPACE_BUTTON_CLICKED");

    static RENDERED_VIEW_REQUIRES_MEMBER_SPACE_CALENDAR = Symbol("RENDERED_VIEW_REQUIRES_MEMBER_SPACE_CALENDAR");
    static BLOCK_ALL_MEMBER_SPACE_CALENDAR_CLICKED = Symbol("BLOCK_ALL_MEMBER_SPACE_CALENDAR_CLICKED");
    static UNBLOCK_ALL_MEMBER_SPACE_CALENDAR_CLICKED = Symbol("UNBLOCK_ALL_MEMBER_SPACE_CALENDAR_CLICKED");
    static BLOCK_DATES_MEMBER_SPACE_CALENDAR_CLICKED = Symbol("BLOCK_DATES_MEMBER_SPACE_CALENDAR_CLICKED");
    static UNBLOCK_DATES_MEMBER_SPACE_CALENDAR_CLICKED = Symbol("UNBLOCK_DATES_MEMBER_SPACE_CALENDAR_CLICKED");
    static CURRENT_MEMBER_CALENDAR_SELECTION_RANGE_CHANGED = Symbol("CURRENT_MEMBER_CALENDAR_SELECTION_RANGE_CHANGED");
    static DONE_WITH_SPACE_CALENDAR_MANAGEMENT_CLICKED = Symbol("DONE_WITH_SPACE_CALENDAR_MANAGEMENT_CLICKED");
    static CLOSE_RESERVATION_CROSSING_SELECTION_ERROR_ALERT = Symbol("CLOSE_RESERVATION_CROSSING_SELECTION_ERROR_ALERT");

    static LOAD_IMAGES_FOR_EDIT = Symbol("LOAD_IMAGES_FOR_EDIT");
    static REST_IMAGE_STORE = Symbol("REST_IMAGE_STORE");
    static ADVERTISEMENT_EDIT_SAVE_SUBMITTED = Symbol("ADVERTISEMENT_EDIT_SAVE_SUBMITTED");
    static ADVERTISEMENT_EDIT_TITLE_CHANGED = Symbol("ADVERTISEMENT_EDIT_TITLE_CHANGED");
    static ADVERTISEMENT_EDIT_DESCRIPTION_CHANGED = Symbol("ADVERTISEMENT_EDIT_DESCRIPTION_CHANGED");
    static ADVERTISEMENT_EDIT_SET_ADVERTISEMENT_ID = Symbol("ADVERTISEMENT_EDIT_SET_ADVERTISEMENT_ID");

    static ADVERTISEMENT_BILLING_MOUNTED = Symbol("ADVERTISEMENT_BILLING_MOUNTED");
    static ADVERTISEMENT_BILLING_SELECTED_MONTH_CHANGED = Symbol("ADVERTISEMENT_BILLING_SELECTED_MONTH_CHANGED");
    static ADVERTISEMENT_BILLING_UNMOUNTED = Symbol("ADVERTISEMENT_BILLING_UNMOUNTED");

    static SPACE_BALANCE_MOUNTED = Symbol("SPACE_BALANCE_MOUNTED");
    static SPACE_BALANCE_SELECTED_MONTH_CHANGED = Symbol("SPACE_BALANCE_SELECTED_MONTH_CHANGED");
    static SPACE_BALANCE_UNMOUNTED = Symbol("SPACE_BALANCE_UNMOUNTED");

    static SPACE_RESERVATIONS_UNMOUNTED = Symbol("SPACE_RESERVATIONS_UNMOUNTED");
    static ADVERTISEMENT_RESERVATIONS_UNMOUNTED = Symbol("ADVERTISEMENT_RESERVATIONS_UNMOUNTED");
    static GET_MEMBER_SPACES_RESERVATIONS = Symbol("GET_MEMBER_SPACES_RESERVATIONS");
    static GET_MEMBER_ADVERTISEMENTS_RESERVATIONS = Symbol("GET_MEMBER_ADVERTISEMENTS_RESERVATIONS");

    static RESERVATION_REQUESTS_SPACE_BUTTON_CLICKED = Symbol("RESERVATION_REQUESTS_SPACE_BUTTON_CLICKED");
    static ACCEPTED_RESERVATIONS_SPACE_BUTTON_CLICKED = Symbol("ACCEPTED_RESERVATIONS_SPACE_BUTTON_CLICKED");
    static HISTORY_SPACE_RESERVATION_SPACE_BUTTON_CLICKED = Symbol("HISTORY_SPACE_RESERVATION_SPACE_BUTTON_CLICKED");
    static RESERVATION_REQUESTS_ADVERTISEMENT_BUTTON_CLICKED = Symbol("RESERVATION_REQUESTS_ADVERTISEMENT_BUTTON_CLICKED");
    static ACCEPTED_RESERVATIONS_ADVERTISEMENT_BUTTON_CLICKED = Symbol("ACCEPTED_RESERVATIONS_ADVERTISEMENT_BUTTON_CLICKED");
    static HISTORY_SPACE_RESERVATION_ADVERTISEMENT_BUTTON_CLICKED = Symbol("HISTORY_SPACE_RESERVATION_ADVERTISEMENT_BUTTON_CLICKED");
    static ADVERTISEMENT_OWNER_CONTACT_INFO_BUTTON_CLICKED = Symbol("ADVERTISEMENT_OWNER_CONTACT_INFO_BUTTON_CLICKED");
    static REJECT_SPACE_RESERVATION_BUTTON_CLICKED = Symbol("REJECT_SPACE_RESERVATION_BUTTON_CLICKED");
    static ACCEPT_SPACE_RESERVATION_BUTTON_CLICKED = Symbol("ACCEPT_SPACE_RESERVATION_BUTTON_CLICKED");
    static PENDING_RESERVATIONS_CHECKOUT_BUTTON_CLICKED = Symbol("PENDING_RESERVATIONS_CHECKOUT_BUTTON_CLICKED");

    static PRIVATE_SPACE_DETAILS_CREATE_NEW_ADVERTISEMENT_CLICKED = Symbol("PRIVATE_SPACE_DETAILS_CREATE_NEW_ADVERTISEMENT_CLICKED");
    static PRIVATE_SPACE_DETAILS_ADVERTISEMENT_SELECT_CHANGED = Symbol("PRIVATE_SPACE_DETAILS_ADVERTISEMENT_SELECT_CHANGED");
    static PRIVATE_SPACE_DETAILS_CALENDAR_SELECT_RANGE_CHANGED = Symbol("PRIVATE_SPACE_DETAILS_CALENDAR_SELECT_RANGE_CHANGED");
    static PRIVATE_SPACE_DETAILS_CLOSE_RANGE_CROSSING_ALERT_CLICKED = Symbol("PRIVATE_SPACE_CLOSE_RANGE_CROSSING_ALERT_CLICKED");
    static PRIVATE_SPACE_DETAILS_CLOSE_SELECTED_RANGE_TOO_SHORT_ALERT_CLICKED = Symbol("PRIVATE_SPACE_DETAILS_CLOSE_SELECTED_RANGE_TOO_SHORT_ALERT_CLICKED");
    static PRIVATE_SPACE_DETAILS_RESERVATION_REQUEST_CLICKED = Symbol("PRIVATE_SPACE_DETAILS_RESERVATION_REQUEST_CLICKED");
    static PRIVATE_SPACE_DETAILS_UNMOUNTED = Symbol("PRIVATE_SPACE_DETAILS_UNMOUNTED");

    static CHECKOUT_VIEW_MOUNTED = Symbol("CHECKOUT_VIEW_MOUNTED");
    static CHECKOUT_VIEW_UNMOUNTED = Symbol("CHECKOUT_VIEW_UNMOUNTED");
    static CHECKOUT_CARD_DETAILS_CHANGED = Symbol("CHECKOUT_CARD_DETAILS_CHANGED");
    static CHECKOUT_PAY_CLICKED = Symbol("CHECKOUT_PAY_CLICKED");
    static CHECKOUT_PAYMENT_FAILURE_CLEAR_CLICKED = Symbol("CHECKOUT_PAYMENT_FAILURE_CLEAR_CLICKED");
    static CHECKOUT_CANCEL_CLICKED = Symbol("CHECKOUT_CANCEL_CLICKED");

    static SPACE_OWNER_CONTACT_INFO_BUTTON_CLICKED = Symbol("SPACE_OWNER_CONTACT_INFO_BUTTON_CLICKED");
    static PROFILE_EDIT_DISPLAY_NAME_CHANGED = Symbol("PROFILE_EDIT_DISPLAY_NAME_CHANGED");
    static PROFILE_EDIT_EMAIL_CHANGED = Symbol("PROFILE_EDIT_EMAIL_CHANGED");
    static PROFILE_EDIT_PHONE_NUMBER_CHANGED = Symbol("PROFILE_EDIT_PHONE_NUMBER_CHANGED");
    static PROFILE_EDIT_ABOUT_CHANGED = Symbol("PROFILE_EDIT_ABOUT_CHANGED");
    static PROFILE_EDIT_PAYMENT_ADDRESS_NAME_CHANGED = Symbol("PROFILE_EDIT_PAYMENT_ADDRESS_NAME_CHANGED");
    static PROFILE_EDIT_ADDRESS_AUTOCOMPLETE_CHANGED = Symbol("PROFILE_EDIT_ADDRESS_AUTOCOMPLETE_CHANGED");
    static PROFILE_EDIT_SECONDARY_ADDRESS_CHANGED = Symbol("PROFILE_EDIT_SECONDARY_ADDRESS_CHANGED");
    static PROFILE_EDIT_SAVE_SUBMITTED = Symbol("PROFILE_EDIT_SAVE_SUBMITTED");

}

export default UIInteractionEvents;